<template>
  <div class="poster" @touchmove.prevent>
    <div class="poster-mask">
      <div class="poster-box" @click.stop="bindStop">
        <div class="container">
          <img class="poster-result" :src="imgUrl" />
        </div>
      </div>
    </div>
    <ShareComponent
      v-if="imgUrl"
      class="share-container"
      :shareType="shareType"
      @image="bindClick"
      @close="bindClose"
    />
  </div>
</template>
<script>
import ShareComponent from './share.vue'
import html2canvas from 'html2canvas'
export default {
  components: {
    ShareComponent
  },
  props: {
    //元素id
    el: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoadImage: false, //海报底图是否加载完成
      imgUrl: '', //图片base64资源
      isCreatePoster: false,
      inviteUrl: '', // 复制的链接
      shareType: 1 //分享类型  默认0是链接 1是分享图
    }
  },
  created() {},
  mounted() {
    this.$toast.loading('生成海报中...')
    window.scrollTo(0, 0)
    setTimeout(() => {
      this.creatPoster()
    }, 200)
  },
  methods: {
    //海报图片加载完成之后才能生成图片
    bindLoadImage() {
      console.log('图片加载完成')
      this.isLoadImage = true
    },
    //阻止冒泡事件
    bindStop() {},
    //点击分享组件中对应的按钮触发对应的事件
    bindClick(index) {
      switch (index) {
        case 0:
          this.handelSaveImg()
          break
        case 1:
          this.shareFriend(1)
          break
        case 2:
          this.shareWechatCicle(1)
          break
        case 3:
          break
      }
    },
    bindClose() {
      this.$emit('close')
    },
    //分享到微信好友
    shareFriend(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc: '为你专属定制的减脂营养服务，立即免费领取',
            title: '吃饱也能瘦？专业营养师在线饮食指导',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_thumbnail' // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.imgUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc: '为你专属定制的减脂营养服务，立即免费领取',
            title: '吃饱也能瘦？专业营养师在线饮食指导',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_thumbnail' // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信朋友圈
    shareWechatCicle(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc: '为你专属定制的减脂营养服务，立即免费领取',
            title: '吃饱也能瘦？专业营养师在线饮食指导',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_thumbnail' // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.imgUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc: '为你专属定制的减脂营养服务，立即免费领取',
            title: '吃饱也能瘦？专业营养师在线饮食指导',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_thumbnail' // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信
    shareWechat(obj) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppShare(obj)
      }
    },
    //生成海报
    creatPoster() {
      if (!this.el) {
        this.$toast('未获取到元素id')
        this.$emit('error')
        return
      }
      let el = document.getElementById(this.el)
      html2canvas(el, {
        backgroundColor: null,
        useCORS: true
      })
        .then((canvas) => {
          this.$toast.clear()
          this.imgUrl = canvas.toDataURL()
          this.$toast('图片已生成')
          this.$emit('success')
        })
        .catch((err) => {
          console.log(err)
          this.$toast.clear()
          this.$toast('生成图片失败')
          this.$emit('error')
        })
        .finally(() => {
          this.isCreatePoster = false
        })
    },
    //保存图片
    handelSaveImg() {
      console.log('保存到手机成功')
      if (this.$http._isApp()) {
        this.$betterwe.onAppSaveImage({
          data: this.imgUrl, //分享的具体数据
          //分享的数据的格式
          //type=base64  表示图片格式是base64   type=url  表示图片格式是链接
          type: 'base64'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.poster {
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 12;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  .poster-mask {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .poster-box {
    height: 100%;
    padding: 30px 20px 180px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .container {
      width: 100%;
      position: relative;
      height: 100%;
    }
    .opacity {
      width: 100%;
      height: 100%;
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .poster-result {
      width: 100%;
      height: 100%;
      position: relative;
      z-index: 9;
      object-fit: contain;
    }
    .share-poster {
      display: inline-block;
      position: relative;
      .share-image {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
      .qrcode {
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 90px;
        height: 90px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      #qrcode-canvas {
        width: 100%;
        height: 100%;
      }
    }
  }
  .share-container {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 10;
  }
}
</style>
